import { useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { CandidateDetailFragment } from 'generated/resources/graphql'

import { CandidateFeedbacks } from '../components/CandidateFeedbacks'

const CandidateNotesPage = () => {
  const { candidate } = useOutletContext<{ candidate: CandidateDetailFragment }>()

  return (
    <Box>
      <CandidateFeedbacks candidate={candidate} />
    </Box>
  )
}

export default CandidateNotesPage
